import { Skeleton } from '@/_components/ui/skeleton'
import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { Container } from '@/features/_components/ui/container'
import { useCompanyContext } from '@/features/_contexts/company-context'
import { CompanyHeader } from '../_components/company-header'
import { CompanyHeaderLoading } from '../_components/company-header-loading'
import { CompanySettingsForm } from './_components/company-settings-form'
import { EditProvider } from './_providers/edit'
import { FormProvider } from './_providers/form-provider'

const CompanySettings = ({ session }: WithAuthComponentProps) => {
  const company = useCompanyContext()
  const isStaff = session.user.userType === 'staff'

  if (!company) {
    return (
      <Container className="px-14 py-10 gap-6">
        <CompanyHeaderLoading showBack={isStaff} showTabs={isStaff} />
        <div className="flex flex-col gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-12 w-full rounded-md" />
          ))}
        </div>
      </Container>
    )
  }

  return (
    <EditProvider>
      <FormProvider company={company}>
        <Container className="px-14 py-10 gap-6">
          <CompanyHeader
            company={company}
            backHref={isStaff ? '/companies' : undefined}
            breadcrumbs={
              isStaff
                ? [{ label: 'Empresas', href: '/companies' }, { label: company.name }]
                : [{ label: 'Sua Instituição' }]
            }
            tabs={isStaff ? { showPersons: true, showUsers: true, showSettings: true } : undefined}
          />
          <CompanySettingsForm company={company} canEdit={isStaff} />
        </Container>
      </FormProvider>
    </EditProvider>
  )
}

export default WithAuth(CompanySettings, { allowedFor: ['staff'] })
